var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard md-layout md-size-80 md-small-size-90" },
    [
      _c("portfolio-widget", {
        staticClass: "md-layout-item",
        attrs: {
          currentAsset: _vm.currentToken,
          accountState: _vm.accountState,
          tronSum: _vm.sumTron,
          subwallets: []
        },
        on: { "asset-change": _vm.setCurrentAsset }
      }),
      _vm._v(" "),
      _c("info-widget", {
        staticClass: "md-layout-item",
        attrs: {
          currentAsset: _vm.currentToken,
          accountState: _vm.accountState
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42eedc4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42eedc4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/Dashboard.Old.Index.vue
// module id = hodE
// module chunks = 1